export interface EmbedOidcFormValues {
  clientRecordId: string
}

export const emptyEmbedOidcFormValues: EmbedOidcFormValues = {
  clientRecordId: '',
}
